import { useEffect } from 'react';
import { useFlightsStore } from '../stores/flightsStore';

export const useFlights = () => {
  const { flights, loading, error, fetchFlights } = useFlightsStore();

  useEffect(() => {
    fetchFlights();
  }, [fetchFlights]);

  return {
    flights: Object.values(flights),
    loading,
    error,
    isEmpty: Object.keys(flights).length === 0
  };
};